import React from 'react';

// hooks
import { useFetchWorkspaces } from 'Shared/utils/hooks';

// components
import Spinner from 'Shared/components/Spinner';
import TeamGroupSection from 'Shared/components/navigation/TeamGroupSection/TeamGroupSection';
import CreateWorkspaceButton from 'Shared/components/CreateWorkspaceButton/CreateWorkspaceButton';

// styles
import './ZoomLandingPage.scss';

const ZoomLandingPage = () => {
  const [isWorkspaceFetching] = useFetchWorkspaces();

  return (
    <div className="ZoomLandingPage">
      {isWorkspaceFetching ? (
        <Spinner activeIf />
      ) : (
        <div className="ZoomLandingPage__content">
          <h5 className="ZoomLandingPage__header">Select a workspace to get started</h5>
          <div className="ZoomLandingPage__action">
            <CreateWorkspaceButton />
          </div>
          <TeamGroupSection />
        </div>
      )}
    </div>
  );
};

export default ZoomLandingPage;
